/* 🤖 this file was generated by svg-to-ts */
export const IconBigBoldWinkelUnten: {
    name: 'big-bold-winkel-unten';
    data: string;
} = {
    name: 'big-bold-winkel-unten',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M64 97.84a11.47 11.47 0 0 1-8.13-3.36L2.7 41.3a7.5 7.5 0 0 1 10.6-10.6L64 81.39l50.7-50.69a7.5 7.5 0 0 1 10.6 10.6L72.13 94.48A11.47 11.47 0 0 1 64 97.84"/></svg>`,
};
